import {baseUrl} from'../config';

export const rolesController ={
    GetAllRoles:baseUrl+'/api/role'
}